import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../redux/Authentication";
import { post } from '../../services/ApiService';
import toast, { Toaster } from 'react-hot-toast';
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [focusedField, setFocusedField] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email || !password) {
            toast.error('Please fill in all fields');
            return;
        }

        try {
            setIsLoading(true);
            const res = await post(`api/auth/login`, { email, password });
            
            if (res.success) {
                if (res.mfaRequired) {
                    setIsLoading(false);
                    setEmail('');
                    setPassword('');
                    navigate('/mfa', { state: { tempToken: res.tempToken, isNewUser: res.isNewUser } });
                    return;
                }
                toast.success('Login successfully');
                dispatch(loginSuccess(res.user));
                
                navigate(res.user.isNewUser ? '/change-password' : '/');
            } else {
                toast.error(res.error || 'Invalid credentials');
            }
        } catch (error) {
            toast.error('Connection error');
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Toaster 
                position="top-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: '#1a1a1a',
                        color: '#fff',
                        fontSize: '14px',
                        borderRadius: '8px'
                    }
                }} 
            />
            
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                background: '#fafafa'
            }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            {/* Card */}
                            <div style={{
                                background: '#ffffff',
                                borderRadius: '24px',
                                padding: '48px 40px',
                                boxShadow: '0 20px 40px -10px rgba(0,0,0,0.1)'
                            }}>
                                {/* Logo */}
                                <div style={{ 
                                    marginBottom: '20px' 
                                }}>
                                    <img 
                                        src='/assets/images/logo.svg' 
                                        alt="Company Logo"
                                        className="light-mode-img invert_logo"
                                        style={{ 
                                            height: '60px',
                                            width: '200px'
                                        }} 
                                    />
                                </div>

                                {/* Header */}
                                <div style={{ marginBottom: '40px' }}>
                                    <p style={{
                                        fontSize: '15px',
                                        color: '#666',
                                        marginLeft:"10px"
                                    }}>
                                        Welcome back! Please enter your details.
                                    </p>
                                </div>

                                {/* Form */}
                                <form onSubmit={handleSubmit}>
                                    {/* Email Field */}
                                    <div style={{ marginBottom: '24px' }}>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#333',
                                            marginBottom: '8px'
                                        }}>
                                            Email Address
                                        </label>
                                        <div style={{
                                            position: 'relative'
                                        }}>
                                            <input
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                onFocus={() => setFocusedField('email')}
                                                onBlur={() => setFocusedField(null)}
                                                placeholder="name@company.com"
                                                disabled={isLoading}
                                                style={{
                                                    width: '100%',
                                                    padding: '14px 16px',
                                                    fontSize: '15px',
                                                    border: `2px solid ${focusedField === 'email' ? '#111' : '#e5e5e5'}`,
                                                    borderRadius: '12px',
                                                    outline: 'none',
                                                    transition: 'all 0.2s ease',
                                                    backgroundColor: '#fff'
                                                }}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Password Field */}
                                    <div style={{ marginBottom: '32px' }}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '8px'
                                        }}>
                                            <label style={{
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                color: '#333'
                                            }}>
                                                Password
                                            </label>
                                            <Link 
                                                to="/forgot-password"
                                                style={{
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    textDecoration: 'none',
                                                    transition: 'color 0.2s'
                                                }}
                                                onMouseEnter={(e) => e.target.style.color = '#111'}
                                                onMouseLeave={(e) => e.target.style.color = '#666'}
                                            >
                                                Forgot password?
                                            </Link>
                                        </div>
                                        <input
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            onFocus={() => setFocusedField('password')}
                                            onBlur={() => setFocusedField(null)}
                                            placeholder="••••••••"
                                            disabled={isLoading}
                                            style={{
                                                width: '100%',
                                                padding: '14px 16px',
                                                fontSize: '15px',
                                                border: `2px solid ${focusedField === 'password' ? '#111' : '#e5e5e5'}`,
                                                borderRadius: '12px',
                                                outline: 'none',
                                                transition: 'all 0.2s ease',
                                                backgroundColor: '#fff'
                                            }}
                                            required
                                        />
                                    </div>

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className="btn btn-primary w-100"
                                    >
                                        {isLoading ? 'Signing in...' : 'Sign in'}
                                    </button>

                                </form>
                            </div>

                            {/* Footer */}
                            <div style={{
                                textAlign: 'center',
                                marginTop: '24px'
                            }}>
                                <span style={{
                                    fontSize: '13px',
                                    color: '#999'
                                }}>
                                    © 2024 Pillpharm. All rights reserved.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;